// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import "expose-loader?jQuery!jquery"; // eslint-disable-line
import "expose-loader?$!jquery"; // eslint-disable-line
import $ from 'jquery';
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueTouch from "vue-touch";
import Trend from "vuetrend";
import trumbowyg from "vue-trumbowyg";
import { ClientTable } from "vue-tables-2";
import VueTextareaAutosize from "vue-textarea-autosize";
import { VueMaskDirective } from "v-mask";
import VueFormWizard from "vue-form-wizard";
import Toasted from 'vue-toasted';
import { Icon } from "leaflet";
import moment from "moment";
import VueKindergarten from "vue-kindergarten";
import Donut from 'vue-css-donut-chart';
import { isEmpty } from 'lodash';
import VueTimeago from 'vue-timeago';
import api from "@/_services/api";
import { store } from "./_store";
import { router } from "./_helpers";
import { basePerimeter } from '@/_perimeters';
import child from '@/_kindergarten/child';
import App from "./App";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueTouch);
Vue.use(Trend);
Vue.use(trumbowyg);
Vue.use(ClientTable, { theme: "bootstrap4" });
Vue.use(VueTextareaAutosize);
Vue.directive("mask", VueMaskDirective);
Vue.use(VueFormWizard);
Vue.use(Toasted, {
  position: "top-center"
});
Vue.use(VueKindergarten, {
  child
});
Vue.use(Donut);
Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en'
});

Vue.config.productionTip = false;

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.filter("formatDate", function (date, dateOnly = false) {
  return !isEmpty(date) ? dateOnly ? moment(date).format("DD/MM/YYYY") : moment(date).format("DD/MM/YYYY HH:mm:ss") : 'Unknown';
});
Vue.filter("dashToSpace", function (value) {
  if (!value) return '';
  return value.replace(/_+/g, ' ');
});

Vue.mixin({
  methods: {
    isNumeric: value => $.isNumeric(value)
  }
});
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'

function tokenInterceptor () {
  if (!Vue.prototype.$keycloak.hasResourceRole("LOGIN")) {
    router.push('/app/main/access-denied')
    return
  }
  api.interceptors.request.use(config => {
    if (Vue.prototype.$keycloak.authenticated) {
      config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    }
    return config
  }, error => {
    return Promise.reject(error)
  })
}
Vue.use(VueKeyCloak, {
  config: {
    url: window.appConfig ? window.appConfig.keycloakAuthUrl : process.env.VUE_APP_KEYCLOAK_AUTH_URL,
    realm: window.appConfig ? window.appConfig.keycloakRealm : process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: "linesight-web"
  },
  init: {
    onLoad: "login-required",
    checkLoginIframe: false
  },
  onReady: () => {
    tokenInterceptor()
    new Vue({
      el: "#app",
      perimeters: [
        basePerimeter
      ],
      store,
      router,
      render: h => h(App)
    });
    /* eslint-disable no-new */
  }
})
/* eslint-disable no-new */
